module.exports = __webpack_public_path__ + "img/logout.3b704aed.png";